export const COLORS = {
  background: "#0a0a0a",
  accent: "#ffb41f",
  text: "#f0f0f0",
};

export default COLORS;
